import './App.css';
import AllRoutes from './routes/allRoutes';
import { TenantProvider } from './context/TenantContext';
import { AuthProvider } from './context/AuthContext';

function App() {
  return (
    <TenantProvider>
      <AuthProvider>
        <div className="App">
          <AllRoutes/>
        </div>
      </AuthProvider>
    </TenantProvider>
  );
}

export default App;
